import { render, staticRenderFns } from "./ManagePublicAnnouncements.vue?vue&type=template&id=ce8e8d52&scoped=true"
import script from "./ManagePublicAnnouncements.vue?vue&type=script&lang=js"
export * from "./ManagePublicAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./ManagePublicAnnouncements.vue?vue&type=style&index=0&id=ce8e8d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8e8d52",
  null
  
)

export default component.exports